import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Loading, Space } from 'tdesign-react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { fetchFlowList } from '@/slices/execFlowSlice';
import ListPanel from '@/components/ListPanel';
import NoData from '@/components/NoData';
import Card from './components/Card';

function ExecutiveFlow({ list, loading, fetchFlowList }) {
  useEffect(() => {
    fetchFlowList({ startIndex: 1, pageSize: 99999 });
  }, [fetchFlowList]);

  return (
    <Loading loading={loading}>
      <Root header='流程执行' tip='选择下面的流程开始执行，并按照提示完成变量填写、机器选择'>
        {isEmpty(list) ? (
          <NoData style={{ height: 400 }} />
        ) : (
          <Space size={[14, 20]} breakLine>
            {list.map((item) => (
              <Card key={item.id} detail={item} />
            ))}
          </Space>
        )}
      </Root>
    </Loading>
  );
}

export default connect(
  (state) => ({
    list: state.execFlow.flowList,
    loading: state.execFlow.flowListFetching,
  }),
  {
    fetchFlowList,
  },
)(ExecutiveFlow);

const Root = styled(ListPanel)`
  min-height: 400px;
  .as-panel {
    min-width: 600px;
    background-color: transparent;
    box-shadow: none;
  }
  .shadow-card-body {
    padding: 0;
    background-color: transparent;
  }
`;
